export class AuthError extends Error {}
export class DuplicateAccountError extends AuthError {
  constructor(existingAccountId) {
    super('Duplicate account');
    this.type = 'DuplicateAccount';
    this.name = 'DuplicateAccountError';
    this.existingAccountId = existingAccountId;
  }
  toAuthError() {
    return {
      type: this.type,
      existingAccountId: this.existingAccountId
    };
  }
}
export class AuthenticateError extends AuthError {
  constructor(message, upstreamErrorMessage) {
    super(message);
    this.type = 'AuthenticateError';
    this.name = 'AuthenticateError';
    this.upstreamErrorMessage = upstreamErrorMessage;
  }
  toAuthError() {
    return {
      type: this.type,
      message: this.message,
      upstreamErrorMessage: this.upstreamErrorMessage
    };
  }
}